import React from "react";
import PropTypes from "prop-types";
import { DropdownButton, Dropdown } from "react-bootstrap";
import './staticDropdown.css';

// SubmenuView: unchanged logic, but now just for consistency, onClick instead of onChange
export const SubmenuView = ({ menues, onChange }) => (
  <ul className="sub-menu">
    {Object.keys(menues).map(menuKey => (
      <li
        key={menues[menuKey].value}
      >
        <button onClick={() => onChange(menues[menuKey])}>
          {menues[menuKey].value}
        </button>
      </li>
    ))}
  </ul>
);

SubmenuView.propTypes = {
  menues: PropTypes.object,
  onChange: PropTypes.func,
};

export const FilterView = props => {
  const definedTitle = props.selectedValue;
  const title = definedTitle || props.title;
  const withUnit = `${title} ${props.unit}`;

  return (
    <DropdownButton
      className="dropdown btn-group"
      title={props.unit ? withUnit : title}
      id="dropdown-size-medium"
    >
      {/* Static menus with objects */}
      {!props.useData && props.menues &&
        Object.keys(props.menues).map(menuKey => {
          const menu = props.menues[menuKey];
          return (
            <Dropdown.Item
              key={menu.key}
              eventKey={menu.key}
              onClick={() => {
                if (!menu.submenues) {
                  props.onSelect(menu); // Send entire menu object
                }
              }}
            >
              <div className="menu-item  menu-container">
                {menu.value}
                {menu.submenues &&
                  <SubmenuView
                    menues={menu.submenues}
                    onChange={subMenu => props.onSelect(menu, subMenu)} // Pass both parent and child
                  />
                }
              </div>
            </Dropdown.Item>
          );
        })
      }

      {/* All option */}
      {props.useData && props.data && props.showAll &&
        <Dropdown.Item eventKey="all" onClick={() => props.onSelect("all")}>
          <div className="menu-item">All</div>
        </Dropdown.Item>
      }

      {/* Data-driven menu: value only */}
      {props.useData && props.data?.map((dataItem) => {
        let displayValue;
        let key;
        let label;

        if (props.dataKey) {
          displayValue = props.dataKey === "name" ? dataItem : dataItem[props.dataKey];
          key = `${props.dataKey}-${displayValue}`;
          label = dataItem[props.dataKey];
        } else {
          displayValue = dataItem;
          key = `${displayValue}`;
          label = dataItem;
        }

        return (
          <Dropdown.Item
            key={key}
            eventKey={displayValue}
            onClick={() => props.onSelect(displayValue)}
          >
            <div className="menu-item">{label}</div>
          </Dropdown.Item>
        );
      })}



      {/* No data */}
      {props.useData && (!props.data || props.data.length === 0) &&
        <Dropdown.Item eventKey="" disabled>
          No {props.title || 'Data'} Exists
        </Dropdown.Item>
      }

      {/* Reset */}
      {props.useData && props.data && props.selectedValue && props.showReset &&
        <Dropdown.Item eventKey="reset" onClick={() => props.onSelect("reset")}>
          <div className="menu-item">Reset</div>
        </Dropdown.Item>
      }
    </DropdownButton>
  );
};

FilterView.propTypes = {
  title: PropTypes.string,
  useData: PropTypes.bool,
  unit: PropTypes.string,
  menues: PropTypes.object,
  data: PropTypes.array,
  dataKey: PropTypes.string,
  selectedValue: PropTypes.any,
  onSelect: PropTypes.func,
  showAll: PropTypes.bool,
  showReset: PropTypes.bool,
};


